import { EVENT_STATE_MAIN_COLORS, NeedsAttentionState } from '../../../liveView/LiveView';

const NEUTRAL_COLOR = '#666';
const PALETTE = [
    // Some very pretty colors.
    '#54babc',
    '#03a300',
    '#ff0000',
    '#ffe600',
    '#ff9500',
    '#ff00e1',
];

export const getColorFromPalette = (index: number | null) =>
    index === null ? NEUTRAL_COLOR : PALETTE[index % PALETTE.length];

export const getColorFromLegendState = (legendState: NeedsAttentionState | null | undefined) => {
    if (!legendState) return NEUTRAL_COLOR;
    return EVENT_STATE_MAIN_COLORS[legendState];
};
